import { render, staticRenderFns } from "./TelegramContractors.vue?vue&type=template&id=69063806"
import script from "./TelegramContractors.vue?vue&type=script&lang=js"
export * from "./TelegramContractors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports